import { useSelector } from "react-redux";
import { CreateStatus } from "../../../store/status-store/status-actions"; 
import StatusForms from "../../../components/Forms/StatusForms";
import { GetStatuses } from "../../../store/status-store/status-actions";
import { getTokenInfo } from "../../../utils/Guard";

const StatusCreate = () => {
  const userInfo = getTokenInfo();
  const status = useSelector((state) => state.status.status);
  


  return (
    <>
    <div style={{ backgroundColor: "#133047", padding: "1%", height: "37.1rem" }}>
      <StatusForms actionStatus={CreateStatus} status={status} />
      </div>
    </>
  );
};
export default StatusCreate;
